const EPILOT_ICON_STYLESHEET =
  'https://go.epilot.cloud/elements-static/icons-font/icons.css'
const MATERIAL_ICON_STYLESHEET = '/vendor/material-icons.css'
const MATERIAL_SYMBOL_STYLESHEETS = [
  '/vendor/material-symbols-rounded.css',
  '/vendor/material-symbols-rounded-bold.css'
] as const
const OLD_DESIGN_ICON_STYLESHEETS = [
  EPILOT_ICON_STYLESHEET,
  MATERIAL_ICON_STYLESHEET,
  ...MATERIAL_SYMBOL_STYLESHEETS
] as const

const ensureStylesheet = (href: string) => {
  const hasStylesheet = Array.from(
    document.head.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]')
  ).some((link) => link.getAttribute('href') === href)

  if (hasStylesheet) {
    return
  }

  const link = document.createElement('link')

  link.rel = 'stylesheet'
  link.href = href
  document.head.appendChild(link)
}

export const loadMaterialSymbolStylesheets = () => {
  MATERIAL_SYMBOL_STYLESHEETS.forEach(ensureStylesheet)
}

export const loadOldDesignIconStylesheets = () => {
  OLD_DESIGN_ICON_STYLESHEETS.forEach(ensureStylesheet)
}
